/// <reference types="vite/client" />

export const getApiUrl = (): string => {
    return import.meta.env.VITE_API_URL || 'http://localhost:5268/api';
};

export const getAppName = (): string => {
  return import.meta.env.VITE_APP_NAME || 'Zafiro ERP';
};

export const getAppVersion = (): string => {
  return import.meta.env.VITE_APP_VERSION || '1.0.0';
};


